import { get } from 'lodash';

import { getCurrentSku } from 'state/selectors/pdp';

const getIsSigningUpForProductUpdates = state =>
  get(state, ['mailing', 'signingUpForProductUpdates', getCurrentSku(state)], false);

const getHasSignedUpForProductUpdates = state =>
  get(state, ['mailing', 'signedUpForProductUpdates', getCurrentSku(state)], false);

export { getIsSigningUpForProductUpdates, getHasSignedUpForProductUpdates };
